<template>
    <div class="competDetail_wrap">
        <el-page-header @back="$core.goBack"></el-page-header>
        <div class="banner">
            <div class="banner_content">
                <div class="banner_title">{{ competitionDetailInfo.competitionName }}</div>
                <div class="banner_list">
                    <div class="flex-between">
                        <div>已报名人数</div>
                        <div>{{ competitionDetailInfo.signUpCount }}</div>
                    </div>
                    <div class="flex-between">
                        <div>奖金</div>
                        <div>￥{{ competitionDetailInfo.bonus }}</div>
                    </div>
                    <div class="flex-between">
                        <div>主办方</div>
                        <div>{{ competitionDetailInfo.organizerName }}</div>
                    </div>
                </div>
                <div class="banner_button">
                    <el-button type="primary" v-if="competitionDetailInfo.signUpStatus === 0"
                               @click="showSignUp = true">报名参加
                    </el-button>
                    <el-button type="info" v-else-if="competitionDetailInfo.signUpStatus === 1"
                               @click="showSignUp = true">报名参加
                    </el-button>
                    <el-button type="primary" v-else-if="competitionDetailInfo.signUpStatus === 2"
                               @click="handleShowSubmit">提交作品
                    </el-button>
                    <el-button type="info" v-else>已结束</el-button>
                </div>
            </div>
        </div>
        <div class="competDetail_content">
            <div class="nav_bar">
                <el-steps :active="currentStep" align-center>
                    <el-step v-for="item in progressBarItems" :title="item.title" :key="item.id"
                             :description="item.timestamp">
                    </el-step>
                </el-steps>
            </div>

            <div class="tabs_wrap">
                <el-card class="box-card">
                    <template v-if="showSignUp">
                        <el-page-header @back="showSignUp = false"></el-page-header>
                        <div class="sign_up_wrap">
                            <div class="sign_up_title">
                                报名表
                            </div>
                            <div class="sign_up_content">
                                <el-form :model="signUpForm" label-position="left" :rules="signUpRules" ref="signUpForm"
                                         label-width="110px">
                                    <el-form-item prop="username" label="姓名：">
                                        <el-input v-model="signUpForm.username" placeholder="请输入姓名"></el-input>
                                    </el-form-item>
                                    <el-form-item prop="roleId" label="身份：">
                                        <el-select v-model="signUpForm.roleId" placeholder="请选择身份"
                                                   @change="handleChangeRole">
                                            <el-option label="学生" value="0"></el-option>
                                            <el-option label="在职人员" value="1"></el-option>
                                            <el-option label="其他身份" value="2"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <!--学生-->
                                    <el-form-item prop="schoolId" label="学校：" v-if="signUpForm.roleId == 0">
                                        <div class="flex-between">
                                            <el-select v-model="signUpForm.provinceId" placeholder="选择省份"
                                                       @change="handleProvinceChanged">
                                                <el-option v-for="item in provinceList" :label="item.provinceName"
                                                           :value="item.provinceId" :key="item.provinceId"></el-option>
                                            </el-select>
                                            <el-select v-model="signUpForm.cityId" placeholder="选择城市"
                                                       @change="handleCityChanged">
                                                <el-option v-for="item in cityList" :label="item.cityName"
                                                           :value="item.cityId" :key="item.cityId"></el-option>
                                            </el-select>
                                            <el-select v-model="signUpForm.schoolId" placeholder="选择学校">
                                                <el-option v-for="item in schoolList" :label="item.schoolName"
                                                           :value="item.schoolId" :key="item.schoolId"></el-option>
                                            </el-select>
                                        </div>
                                    </el-form-item>
                                    <el-form-item prop="college" label="二级学院：" v-if="signUpForm.roleId == 0">
                                        <el-input v-model="signUpForm.college" placeholder="请输入二级学院"></el-input>
                                    </el-form-item>
                                    <el-form-item prop="major" label="专业：" v-if="signUpForm.roleId == 0">
                                        <el-input v-model="signUpForm.major" placeholder="请输入专业"></el-input>
                                    </el-form-item>
                                    <!--学生 end-->

                                    <!--在职人员-->
                                    <el-form-item prop="cityId" label="工作城市：" v-if="signUpForm.roleId == 1">
                                        <div class="flex-between">
                                            <el-select v-model="signUpForm.provinceId" placeholder="选择省份"
                                                       @change="handleProvinceChanged">
                                                <el-option v-for="item in provinceList" :label="item.provinceName"
                                                           :value="item.provinceId" :key="item.provinceId"></el-option>
                                            </el-select>
                                            <el-select v-model="signUpForm.cityId" placeholder="选择城市"
                                                       @change="handleCityChanged">
                                                <el-option v-for="item in cityList" :label="item.cityName"
                                                           :value="item.cityId" :key="item.cityId"></el-option>
                                            </el-select>
                                        </div>
                                    </el-form-item>
                                    <el-form-item prop="workField" label="工作领域：" v-if="signUpForm.roleId == 1">
                                        <el-input v-model="signUpForm.workField" placeholder="请输入工作领域"></el-input>
                                    </el-form-item>
                                    <el-form-item prop="workDirection" label="工作方向：" v-if="signUpForm.roleId == 1">
                                        <el-input v-model="signUpForm.workDirection" placeholder="请输入工作方向"></el-input>
                                    </el-form-item>
                                    <!--在职人员 end-->

                                    <!--其他身份-->
                                    <el-form-item prop="explanation" label="补充说明：" v-if="signUpForm.roleId == 2">
                                        <el-input type="textarea"
                                                  :autosize="{ minRows: 4 }"
                                                  maxlength="50"
                                                  show-word-limit
                                                  v-model="signUpForm.explanation"
                                                  placeholder="多行输入">
                                        </el-input>
                                    </el-form-item>
                                    <!--其他身份 end-->

                                    <el-form-item prop="phone" label="联系电话：">
                                        <el-input v-model="signUpForm.phone" placeholder="请输入联系电话"></el-input>
                                    </el-form-item>
                                    <el-form-item prop="email" label="邮箱地址：">
                                        <el-input v-model="signUpForm.email" placeholder="请输入邮箱地址"></el-input>
                                    </el-form-item>
                                    <el-form-item prop="isTeam" label="参赛形式：">
                                        <el-radio-group v-model="signUpForm.isTeam" @change="handleChangeTeam">
                                            <el-radio :label="0">个人</el-radio>
                                            <el-radio :label="1">组队</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item prop="memberList" label="团队成员：" v-if="signUpForm.isTeam">
                                        <template>
                                            <div class="member_list_wrap">
                                                <div class="add_member_btn" @click="handleAddMember">
                                                    <i class="iconfont icon-jia"></i> 添加成员
                                                </div>
                                                <div class="member_content_wrap">
                                                    <div class="member_wrap"
                                                         v-for="(item,index) in signUpForm.memberList">
                                                        <div class="member_title">成员{{ index + 1 }}：
                                                            <div class="del_btn" @click="handleDeleteMember(index)">
                                                                <i class="iconfont icon-shanchu1"></i>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <el-form :model="signUpForm.memberList[index]"
                                                                     :rules="memberListRules" ref="memberListForm">
                                                                <el-form-item prop="username">
                                                                    <el-input
                                                                        v-model="signUpForm.memberList[index].username"
                                                                        placeholder="请输入姓名"></el-input>
                                                                </el-form-item>
                                                                <el-form-item prop="phone">
                                                                    <el-input
                                                                        v-model="signUpForm.memberList[index].phone"
                                                                        placeholder="请输入联系电话"></el-input>
                                                                </el-form-item>
                                                                <el-form-item prop="email">
                                                                    <el-input
                                                                        v-model="signUpForm.memberList[index].email"
                                                                        placeholder="请输入邮箱"></el-input>
                                                                </el-form-item>
                                                            </el-form>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </el-form-item>
                                </el-form>
                            </div>
                            <div class="button_wrap">
                                <el-button type="primary" @click="handleCommit">提交</el-button>
                            </div>
                        </div>
                    </template>

                    <template v-else-if="showSubmit">
                        <el-page-header @back="showSubmit = false"></el-page-header>
                        <div class="sign_up_wrap">
                            <div class="sign_up_title">
                                提交作品
                            </div>
                            <div class="submit_content">
                                <div>
                                    <div class="line_text">
                                        <div class="upload_wrap">
                                            <div class="upload_chooser">
                                                <el-upload
                                                    ref="uploadFile"
                                                    class="upload-demo"
                                                    drag
                                                    action
                                                    :http-request="httpRequest"
                                                    :on-change="handleFileChanged"
                                                    :on-remove="handleFileRemoved"
                                                    :on-exceed="handleExceed"
                                                    :limit="1">
                                                    <i class="el-icon-upload"></i>
                                                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                                                    <div class="el-upload__tip" slot="tip">文件大小不要超过20MB</div>
                                                </el-upload>
                                                <el-button type="primary" @click="handleSubmit"
                                                           :disabled="submitFile===null">
                                                    确认上传
                                                </el-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="submit_record_wrap">
                                    <div class="title">
                                        <el-popover
                                            placement="top-start"
                                            title="提示"
                                            width="200"
                                            trigger="hover"
                                            content="截止日期前可多次上传文件，评审人员会看到最新一次提交的文件">
                                            <el-button icon="el-icon-question" slot="reference" circle
                                                       style="font-size: 18px;padding: 0;border: none"></el-button>
                                        </el-popover>
                                        <i class="iconfont icon-jilu"></i> 提交记录
                                    </div>
                                    <div class="file_wrap">
                                        <div v-for="item in submittedFileList" class="file_item">
                                            <div @click="downloadFile(item.file.fileName,item.file.fileUrl)"
                                                 class="file_title">
                                                {{ item.file.fileName }}
                                            </div>
                                            <div>{{ item.createTime }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>

                    <template v-else>
                        <el-tabs v-model="activeTabs">
                            <el-tab-pane label="竞赛概述" name="tabsOne">
                                <div class="one_wrap">
                                    <div v-for="item in competitionDetailInfo.content[0]">
                                        <div class="line_title">
                                            <el-divider direction="vertical"></el-divider>
                                            <span>{{ item.title }}</span>
                                        </div>
                                        <div class="line_text" v-html="item.content"></div>
                                    </div>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="竞赛数据" name="tabsTwo">
                                <div class="two_wrap">
                                    <div v-for="item in competitionDetailInfo.content[1]">
                                        <div class="line_title">
                                            <el-divider direction="vertical"></el-divider>
                                            <span>{{ item.title }}</span>
                                        </div>
                                        <div class="line_text" v-html="item.content"></div>
                                    </div>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="提交作品说明" name="tabsThree">
                                <div class="three_wrap">
                                    <div v-for="item in competitionDetailInfo.content[2]">
                                        <div class="line_title">
                                            <el-divider direction="vertical"></el-divider>
                                            <span>{{ item.title }}</span>
                                        </div>
                                        <div class="line_text" v-html="item.content"></div>
                                    </div>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="竞赛结果" name="tabsFour">
                                <div class="four_wrap">
                                    <div v-for="item in competitionDetailInfo.content[3]">
                                        <div class="line_title">
                                            <el-divider direction="vertical"></el-divider>
                                            <span>{{ item.title }}</span>
                                        </div>
                                        <div class="line_text" v-html="item.content"></div>
                                    </div>
                                </div>
                            </el-tab-pane>
                        </el-tabs>
                    </template>

                </el-card>
            </div>
        </div>
        <el-dialog :visible.sync="successVisible" width="27%" center>
            <div class="dialog_content">
                <div class="success_wrap">
                    <i class="iconfont icon-chenggong"></i>
                    <div>注册成功</div>
                </div>
                <div class="text">可关注xx赛事公众号获得赛事实时消息</div>
                <div class="button_wrap">
                    <el-button type="primary" @click="successVisible = false,showSignUp=false">确定</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {
    downloadFile,
    getCity,
    getCompetitionInfo,
    getProvince,
    getSchool,
    getSubmittedFileList, signUp,
    submitFile,
    uploadDataFile
} from "@/utils/api";

export default {
    data() {
        return {
            submitFile: null,
            competitionId: this.$route.query.id,
            successVisible: false,
            signUpForm: {
                username: '',
                roleId: "0",
                provinceId: '',
                cityId: '',
                schoolId: '',
                college: '',
                major: '',
                phone: '',
                email: '',
                isTeam: 0,
                workField: '',
                workDirection: '',
                explanation: '',
                memberList: []
            },
            signUpRules: {
                username: [{required: true, message: '请输入学生姓名', trigger: 'blur'}],
                roleId: [{required: true, message: '请选择身份'}],
                phone: [
                    {required: true, message: '请输入手机号', trigger: 'blur'},
                    {pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur'}
                ],
                email: [
                    {required: true, message: '请输入邮箱地址', trigger: 'blur'},
                    {
                        pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
                        message: '请输入正确的邮箱地址',
                        trigger: 'blur'
                    }
                ],
                isTeam: [
                    {required: true, message: '请选择参赛形式'}
                ],
                memberList: [
                    {required: true, message: '请选择团队成员'}
                ]
            },
            memberListRules: {
                username: [{required: true, message: '请输入成员姓名', trigger: 'blur'}],
            },
            showSignUp: false,
            showSubmit: false,
            competitionDetailInfo: {
                signUpCount: '',
                competitionName: '',
                bonus: '',
                organizerName: '',
                content: [],
                hasRegistered: 0,
            },
            submittedFileList: [],
            currentStep: 0,
            activeTabs: 'tabsOne',
            progressBarItems: [
                {
                    id: 0,
                    title: '开始报名',
                    timestamp: '2021-10-15 08:00'
                },
                {
                    id: 1,
                    title: '报名截止',
                    timestamp: '2021-11-25 08:00'
                },
                {
                    id: 2,
                    title: '提交截止',
                    timestamp: '2021-11-30 08:00'
                },
                {
                    id: 3,
                    title: '结果发布',
                    timestamp: '2021-11-31 08:00'
                }
            ],
            provinceList: [],
            cityList: [],
            schoolList: [],
        }
    },
    created() {
        this.getProvinceList();
    },
    mounted() {
        this.competitionId = this.$route.query.competitionId;
        this.getCompetitionInfo();
    },
    destroyed() {
        this.showSignUp = false;
    },
    methods: {
        //获取竞赛任务描述
        getCompetitionInfo() {
            getCompetitionInfo(this.competitionId).then(res => {
                this.competitionDetailInfo = res.data;
                //处理竞赛进程时间
                this.progressBarItems[0].timestamp = res.data.startTime;
                this.progressBarItems[1].timestamp = res.data.endTime;
                this.progressBarItems[2].timestamp = res.data.submitTime;
                this.progressBarItems[3].timestamp = res.data.publishTime;
                //初始化时间进度条
                this.initProgressBar();
                //处理内容content为4个菜单的形式
                this.competitionDetailInfo.content = JSON.parse(res.data.content);
            });
        },
        //处理提交报名表单时选择身份
        handleChangeRole() {
            switch (this.signUpForm.roleId) {
                case "0":
                    //学生身份
                    this.signUpForm.workField = '';
                    this.signUpForm.workDirection = '';
                    this.signUpForm.explanation = '';
                    break;
                case "1":
                    //在职人员身份
                    this.signUpForm.schoolId = '';
                    this.signUpForm.college = '';
                    this.signUpForm.major = '';
                    this.signUpForm.explanation = '';
                    break;
                case "2":
                    //其他身份
                    this.signUpForm.provinceId = '';
                    this.signUpForm.cityId = '';
                    this.signUpForm.schoolId = '';
                    this.signUpForm.college = '';
                    this.signUpForm.major = '';
                    this.signUpForm.workField = '';
                    this.signUpForm.workDirection = '';
            }
        },
        handleChangeTeam() {
            if (this.signUpForm.isTeam == 0) {
                this.signUpForm.memberList = [];
            }
        },
        //提交报名表单
        handleCommit() {
            this.$refs.signUpForm.validate(valid => {
                if (valid) {
                    // //如果是团队报名，检查队员信息填写
                    // if (this.signUpForm.isTeam) {
                    //     this.$refs.memberListForm.validate(valid => {
                    //         if (valid) {
                    //             this.commitInfo();
                    //         }
                    //     });
                    // } else {
                    this.commitInfo();
                    // }
                }
            })
        },
        commitInfo() {
            signUp(this.competitionId, this.signUpForm).then(res => {
                this.$message.success(res.message);
                //重新获取报名情况
                this.getCompetitionInfo();
                this.showSignUp = false;
                this.signUpForm = {
                    username: '',
                    roleId: "0",
                    provinceId: '',
                    cityId: '',
                    schoolId: '',
                    college: '',
                    major: '',
                    phone: '',
                    email: '',
                    isTeam: 0,
                    workField: '',
                    workDirection: '',
                    explanation: '',
                    memberList: []
                }
            });
        },
        initProgressBar() {
            //假设进度条在开头之前，遍历竞赛日期，遇到当前时间小于进度条节点时间说明该进度还未到，停止遍历
            this.currentStep = -1;
            for (let i = 0; i < this.progressBarItems.length; i++) {
                let now = new Date();
                if (now.getTime() < Date.parse(this.progressBarItems[i].timestamp)) {
                    return;
                } else {
                    this.currentStep = i;
                }
            }
        },
        // 获取省份
        getProvinceList() {
            getProvince().then(res => {
                this.provinceList = res.data
            }).catch(err => err)
        },
        // 获取城市列表
        getCityList() {
            getCity(`${this.signUpForm.provinceId}`).then(res => {
                this.cityList = res.data
            }).catch(err => err)
        },
        //改变省
        handleProvinceChanged() {
            this.getCityList()
            this.signUpForm.cityId = ''
            this.signUpForm.schoolId = ''
        },
        //改变市
        handleCityChanged() {
            this.signUpForm.schoolId = ''
            this.getSchoolList()
        },
        //获取学校列表
        getSchoolList() {
            getSchool(`${this.signUpForm.provinceId}/${this.signUpForm.cityId}`).then(res => {
                this.schoolList = res.data
            }).catch(err => err)
        },
        //添加成员
        handleAddMember() {
            this.signUpForm.memberList.push({
                username: '',
                phone: '',
                email: '',
            })
        },
        //删除成员
        handleDeleteMember(index) {
            this.signUpForm.memberList.splice(index, 1);
        },
        //自定义上传操作
        httpRequest(option) {
        },
        //文件超出个数的钩子
        handleExceed() {
            this.$message({type: 'error', message: '一次只能上传一个文件，如作品包含多个文件请以压缩包的形式上传'})
            this.$refs.uploadFile.clearFiles();
        },
        handleFileChanged(file, fileList) {
            if (file.size > 20000000) {
                this.$message.error('文件过大');
                fileList.splice(0, 1)
            } else {
                this.submitFile = file.raw;
            }
        },
        handleFileRemoved() {
            this.submitFile = null;
        },
        handleShowSubmit() {
            this.showSubmit = true;
            getSubmittedFileList(this.competitionId).then(res => {
                this.submittedFileList = res.data;
            });
        },
        handleSubmit() {
            let formData = new FormData();
            formData.append('file', this.submitFile);
            //先上传文件
            uploadDataFile(formData).then(res => {
                let file = {
                    fileName: res.data.name,
                    fileUrl: res.data.fileUrl,
                    submitTime: res.data.createTime,
                }
                //保存并关联文件到竞赛的记录
                submitFile(this.competitionId, file).then(res => {
                    this.$message.success(res.message);
                    //todo 清空当前文件，刷新上传的文件列表
                    this.$refs.uploadFile.clearFiles();
                    this.submitFile = null;
                    getSubmittedFileList(this.competitionId).then(res => {
                        this.submittedFileList = res.data;
                    });
                });
            });
        },
        //下载文件
        downloadFile(fileName, fileUrl) {
            downloadFile(fileName, fileUrl);
        },
    }
}
</script>
<style lang="scss" scoped>
.dialog_content {
    .success_wrap {
        text-align: center;

        .icon-chenggong {
            color: #67C23A;
            font-size: 38px;
        }

        div {
            font-size: 22px;
            color: #67C23A;
            line-height: 2;
        }
    }

    .text {
        height: 60px;
        line-height: 60px;
        text-align: center;
        color: #3C3C3C;
        font-size: 18px;
    }

}

.sign_up_wrap {
    box-sizing: border-box;
    padding: 40px 150px;

    .sign_up_title {
        width: 80%;
        margin: auto;
        height: 80px;
        line-height: 80px;
        color: #5277F7;
        text-align: center;
        letter-spacing: 2px;
        font-weight: bold;
        font-size: 28px;
        border-bottom: 1px solid #5277F7;
    }

    .sign_up_content {
        width: 34%;
        margin: 40px auto;

        ::v-deep .el-form-item__label {
            text-align: right;
        }

        .member_list_wrap {
            display: flex;
            flex-direction: column;

            .add_member_btn {
                font-size: 16px;
                color: #666666;
                text-align: center;
                height: 42px;
                line-height: 42px;
                width: 200px;
                background-color: #FAFAFA;
                border: 1px solid #CCCCCC;
                transition: .3s ease-in-out;

                &:hover {
                    cursor: pointer;
                    background-color: #EEEEEE;
                }
            }

            .member_content_wrap {
                display: flex;
                flex-direction: column;

                .member_wrap {
                    margin: 10px 0;
                    color: #666666;
                    display: flex;
                    flex-direction: column;

                    .member_title {
                        line-height: 24px;
                        font-size: 18px;
                        position: relative;

                        &:hover {
                            .del_btn {
                            }
                        }

                        .del_btn {
                            transition: .3s ease-in-out;
                            position: absolute;
                            z-index: 9999;
                            right: 0;
                            top: 0;
                        }
                    }

                    .el-input {
                        margin: 5px 0;

                        ::v-deep .el-input__inner {
                            width: 300px;
                            height: 42px;
                        }
                    }

                    ::v-deep .is-error {
                        margin-bottom: 20px !important;
                    }
                }
            }
        }
    }

    .submit_content {
        width: 80%;
        margin: 40px auto;

        .submit_record_wrap {
            font-size: 18px;
            background-color: #FAFAFA;
            border-radius: 2px;
            display: flex;
            flex-direction: column;
            padding: 32px 35px;

            .title {
                padding: 10px 30px;
                border-bottom: 1px solid #E6E6E6;

                ::v-deep i {
                    margin-left: 10px;
                    font-size: 18px;
                }
            }

            .file_wrap {
                padding: 20px 64px 0 64px;
                display: flex;
                flex-direction: column;

                .file_item {
                    margin: 5px 0;
                    display: flex;
                    height: 30px;
                    line-height: 30px;
                    justify-content: space-between;

                    .file_title {
                        &:hover {
                            cursor: pointer;
                            text-decoration: underline;
                        }
                    }
                }
            }
        }

        .upload_wrap {
            margin: 0 auto;
            text-align: center;

            .upload_chooser {
                .upload-demo {
                    width: 580px;
                    margin: 0 auto;
                }

                ::v-deep .el-button {
                    width: 200px;
                    height: 42px;
                    margin: 20px auto;
                    transition: .3s ease-in-out;
                }
            }
        }
    }

}

.button_wrap {
    width: 100%;
    text-align: center;

    .el-button {
        width: 150px;
    }
}

.line_text_title {
    color: black;
    font-weight: bold;
    // font-family: '黑体';
}

.notice {
    margin-top: 20px;
    color: #FF5656;
}

.table_wrap {
    width: 65%;
    margin: 20px auto;
}

.one_wrap, .two_wrap, .three_wrap, .four_wrap {
    box-sizing: border-box;
    padding: 40px 30px;

    .line_title {
        color: #5277F7;
        font-size: 22px;
        height: 50px;
        line-height: 50px;
        font-family: '黑体';

        /deep/ .el-divider {
            width: 6px;
            background-color: #5277F7;
        }
    }

    .line_text {
        box-sizing: border-box;
        padding: 15px 35px;
        font-size: 19px;
        color: #3C3C3C;
        line-height: 1.8;

        //自定义wangEditor样式
        ::v-deep ol {
            margin: 10px 0 10px 22px;
            list-style-type: decimal;
        }

        ::v-deep ul {
            margin: 10px 0 10px 22px;
            list-style-type: disc;
        }

        ::v-deep table {
            width: 70%;
            margin: 0 auto;
            border-top: 1px solid #DDDDDD;
            border-left: 1px solid #DDDDDD;
            text-align: center;
        }

        ::v-deep table th {
            color: white;
            background-color: rgb(82, 119, 247);
            border-bottom: 1px solid #DDDDDD;
            border-right: 1px solid #DDDDDD;
            padding: 3px 5px;
            height: 34px;
        }

        ::v-deep table td {
            border-bottom: 2px solid #DDDDDD;
            border-right: 1px solid #DDDDDD;
            background-color: #FAFAFA;
            min-height: 30px;
        }
    }
}

/deep/ .is-active {
    border-bottom: 5px solid #5277F7 !important;
}

/deep/ .el-tabs__nav {
    width: 100%;

    .el-tabs__item {
        width: 25%;
        text-align: center;
        height: 60px;
        line-height: 60px;
        font-size: 25px;
        font-weight: bold;
    }
}

.tabs_wrap {
    margin-bottom: 30px;

    ::v-deep .el-page-header {
        display: contents;
    }
}

.competDetail_content {
    box-sizing: border-box;
    padding: 5px 200px;

    .nav_bar {
        margin: 20px 0;
        box-sizing: border-box;
        padding-top: 40px;
        height: 160px;
        border: 1px solid #5277F7;
        background: white;
        border-radius: 80px;

        /deep/ .el-step__line-inner {
            //border: 0.125rem solid #C0C4CC;
        }

        /deep/ .el-step__title {
            font-weight: bold;
            font-size: 20px;
        }

        /deep/ .el-step__description {
            font-size: 17px;
        }

        /deep/ .is-finish {
            color: #5277F7;

            .el-step__icon.is-text {
                border: 0.125rem solid #5277F7;
            }

            .el-step__line {
                background-color: #5277F7 !important;
            }
        }

        /deep/ .is-process {
            color: #5277F7;

            .el-step__icon.is-text {
                border: 0.125rem solid #5277F7;
            }
        }

        /deep/ .is-wait {
            color: #C0C4CC;

            .el-step__icon.is-text {
                border: 0.125rem solid #C0C4CC;
            }
        }
    }
}

.banner_content {
    min-width: 400px;
    width: 400px;
    max-width: 500px;
    margin: 0px auto;
    padding-top: 50px;
    height: 350px;
    color: #5277F7;

    .banner_title {
        text-align: center;
        height: 80px;
        line-height: 80px;
        font-size: 35px;
        font-weight: bold;
        letter-spacing: 3px;
    }

    .banner_list {
        .flex-between {
            height: 60px;
            line-height: 60px;
            font-size: 23px;

            > div:nth-child(1) {
                font-weight: bold;
            }

            div {
                width: 50%;
                text-align: left;
            }
        }
    }

    .banner_button {
        height: 90px;
        line-height: 90px;

        .el-button {
            width: 100%;
            font-size: 22px;
        }
    }
}

.competDetail_wrap {
    background: #FAFBFF;

    .banner {
        height: 440px;
        width: 100%;
        background: url(../../../assets/img/competeDetail_banner.png) 0 0/100% 100% no-repeat;
    }
}
</style>